module.exports = __webpack_public_path__ + "static/media/az.de1a18a8.png";